import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { accountManagerDashboardFeatureKey, reducer } from './reducers/account-managers-dashboard.reducer';
import { AccountManagerDashboardEffects } from './effects/account-managers-dashboard.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(accountManagerDashboardFeatureKey, reducer),
        EffectsModule.forFeature([AccountManagerDashboardEffects])
    ]
})
export class AccountManagerDashboardStoreModule {}
